import React, { createContext, useContext, useState, useEffect } from 'react';
import AssetModel from "../models/AssetModel";
import {
  getShopItems,
  getShopSkus
} from './BasejumpApiProvider';
import { useTokenAuth } from '../hooks';
import { DiscordSdkContext } from './DiscordSdkProvider';

export const ShopContext = createContext();

export const ShopProvider = ({ children }) => {
  const { isDiscord } = useContext(DiscordSdkContext);
  const { basejumpToken } = useTokenAuth();
  const [items, setItems] = useState([]);
  const [skus, setSkus] = useState([]);

  const fetchShopItems = async () => {
    const [itemsFromApi, skusFromApi] = await Promise.all([
      getShopItems(basejumpToken),
      getShopSkus(basejumpToken)
    ]);
    const assets = itemsFromApi.map(i => (AssetModel.fromBasejumpEquipment({id: i.id, item: i}, isDiscord)));
    setItems(assets);
    setSkus(skusFromApi);
  };

  useEffect(() => {
    (async () => {
      if (basejumpToken) {
        await fetchShopItems();
      }
    })();
  }, [basejumpToken]);

  const value = {
    items,
    skus,
    fetchShopItems
  };

  return (
    <ShopContext.Provider value={value}>
      {children}
    </ShopContext.Provider>
  );
};
